import * as faker from 'faker';

import {pagedQuery} from './helpers';
import {branding} from './branding';

export const mocks = {
    Business: () => ({
        isDeleted: false,
        name: faker.company.companyName(),
    }),

    Address: () => ({
        address1: faker.address.streetAddress(),
        address2: faker.address.secondaryAddress(),
        city: faker.address.city(),
        state: faker.address.stateAbbr(),
        postalCode: faker.address.zipCode(),
        country: 'US',

        isMappable: true,
        lat: faker.address.latitude(),
        long: faker.address.longitude(),
    }),

    Contact: () => ({
        firstName: faker.name.firstName(),
        lastName: faker.name.lastName(),
        email: faker.internet.exampleEmail(),
        phone: faker.phone.phoneNumber('1(###) 555-01##'),
    }),

    ContactInfo: () => ({
        firstName: faker.name.firstName(),
        lastName: faker.name.lastName(),
        email: faker.internet.exampleEmail(),
        phone: faker.phone.phoneNumber('1(###) 555-01##'),
    }),

    defaultBillingTerms: () => ({
        defaultPaymentTerms: 'THIRD_PARTY',
        companyName: faker.company.companyName(),
    }),
};


export const orgs = {};
export const defaultOrgId = 27483;
for (let id = defaultOrgId; id < defaultOrgId + 78; id++) {
    const name = faker.company.companyName();
    orgs[id] = {
        id,
        name,
        orgId: id,
        isDeleted: false,
        externalId: name.replace(/[^A-Z]/g, ""),

        mainBusiness: {
            id,
            name,
            orgId: id,
            isDeleted: false,
        },

        timeZoneId: 'PACIFIC_STANDARD_TIME_US_CANADA',
        config: {
            brandingId: 1,
            branding,

            defaultCountry: 'US',
            defaultCurrency: 'USD',
            defaultUnitType: 'IMPERIAL',
            defaultDensityUnit: 'POUNDS_PER_CUBIC_FOOT',
            defaultDimensionUnit: 'INCHES',
            defaultDistanceUnit: 'MILES',
            defaultVolumeUnit: 'CUBIC_FEET',
            defaultWeightUnit: 'POUNDS',

            organizationTypeId: 'STANDARD',

        },

        orgUsers: [],
    };
}


export const resolvers = {
    OrganizationQueries: {
        byId: (root, {id}) => orgs[id],
        all: () => Object.values(orgs),
        paged: pagedQuery(() => Object.values(orgs)),
    },
};
